import React, { useEffect } from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  OutlinedInput,
  Typography,
  InputAdornment,
  CircularProgress,
  FormHelperText,
  Chip,
  Button
} from '@mui/material'

export default function CartSummary({
  user,
  handlePromoCodeInput,
  promoCodeInput,
  errors,
  promoCodeLoading,
  handlePromoCodeSubmit,
  handlePromoCodeRemove,
  couponApplied,
  discount,
  total,
  mobile
}) {
  const styles = {
    rightBox: {
      gridRow: mobile ? '3/4' : '2 /3',
      gridColumn: mobile ? '1/3' : '2/3',
      display: 'flex',
      flexDirection: 'column',
      padding: '16px',
      borderLeft: mobile ? null : '1px solid lightgray',
      borderTop: mobile ? '1px solid lightgray' : null
    },
    lineItem: {
      display: 'flex',
      justifyContent: 'space-between'
    }
  }
  let savings = 0
  if (couponApplied.value > 0) {
    if (couponApplied.isPercent) {
      savings = couponApplied.value * total
    } else {
      savings = couponApplied.value
    }
  } else {
    savings = discount * total
  }
  return (
    <Box id='right' sx={styles.rightBox}>
      <Box sx={{ flexGrow: 1 }}>
        {user.permissions ? (
          <>
            <FormControl variant='outlined' sx={styles.promoCodeBox}>
              <InputLabel>Promo Code</InputLabel>
              <OutlinedInput
                variant='outlined'
                fullWidth
                label='Add a Valid Promo Code'
                onChange={(e) => handlePromoCodeInput(e)}
                value={promoCodeInput}
                error={errors['coupon']}
                endAdornment={
                  <InputAdornment position='end'>
                    {promoCodeLoading ? (
                      <CircularProgress />
                    ) : promoCodeInput ? (
                      <Button onClick={handlePromoCodeSubmit}>Apply</Button>
                    ) : (
                      <></>
                    )}
                  </InputAdornment>
                }
              />
              {errors['coupon'] ? (
                <FormHelperText sx={{color: 'red'}}>Invalid Promo Code</FormHelperText>
              ) : (
                <></>
              )}
              {couponApplied.value > 0 ? (
                <Chip
                  label={couponApplied.code}
                  onDelete={handlePromoCodeRemove}
                />
              ) : (
                <></>
              )}
            </FormControl>
          </>
        ) : (
          <></>
        )}
        <span style={styles.lineItem}>
          <Typography display='inline'>Subtotal:</Typography>
          <Typography display='inline'>${total.toFixed(2)}</Typography>
        </span>
        {discount > 0 ? (
          <span style={styles.lineItem}>
            <Typography display='inline'>Savings:</Typography>
            <Typography display='inline'>- ${savings.toFixed(2)} </Typography>
          </span>
        ) : (
          <></>
        )}
      </Box>
      <span style={styles.lineItem}>
        <Typography display='inline'> Total: </Typography>
        <Typography display='inline'>
          <b>${(total - savings).toFixed(2)}</b>
        </Typography>
      </span>
    </Box>
  )
}
